import { useEffect, useRef } from 'react'
import StepContainer from './StepContainer'
import StepErrorSummary from './StepErrorSummary'
import StepNavigation from './StepNavigation'
import StepRail from './StepRail'
import TopEdgeProgress from './TopEdgeProgress'
import CustomScrollbar from './CustomScrollbar'
import ThemeToggle from '../ThemeToggle'
import { StepSubmitProvider, useStepSubmit } from '../../context/StepSubmitContext'
import { useOnboardingStore } from '../../stores/onboardingStore'

function EnterKey() {
  const { runHandler } = useStepSubmit()
  const current = useOnboardingStore((s) => s.currentStep)
  const total = useOnboardingStore((s) => s.steps.length)
  const nextStep = useOnboardingStore((s) => s.nextStep)

  useEffect(() => {
    const isTyping = () => {
      const a = document.activeElement
      // Text inputs and textareas submit via Enter through the form handler.
      // Avoid double-firing for selects/other interactive elements.
      return (
        !!a &&
        (a.tagName === 'TEXTAREA' || a.isContentEditable)
      )
    }
    const onKey = (e) => {
      if (e.code !== 'Enter') return
      const withModifier = e.metaKey || e.ctrlKey
      // With Cmd/Ctrl+Enter, always advance — even when typing in an input.
      if (!withModifier) {
        if (isTyping()) return
        const active = document.activeElement
        const inForm = active && active.closest?.('form')
        if (inForm) return
      }
      e.preventDefault()
      const handled = runHandler()
      if (!handled && current < total) nextStep()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [current, total, nextStep, runHandler])

  return null
}

export default function FormShell() {
  const shellRef = useRef(null)
  return (
    <StepSubmitProvider>
      <div className="form-shell" ref={shellRef}>
        <TopEdgeProgress />
        <StepRail />
        <header className="form-top-bar">
          <div className="form-top-left">
            <img
              src="/brite-logo-teal-dark.png"
              alt="Brite"
              style={{ height: 34, width: 'auto', display: 'block' }}
            />
          </div>
          <div className="form-top-center" aria-hidden="true" />
          <div className="form-top-right">
            <ThemeToggle />
          </div>
        </header>

        <main className="form-content">
          <div className="form-content-inner step-fit-viewport">
            <StepContainer />
          </div>
        </main>

        <footer className="form-bottom-bar">
          <div className="bb-left" aria-hidden="true" />
          <div className="bb-center" aria-hidden="true" />
          <div className="bb-right">
            <StepErrorSummary />
            <StepNavigation />
          </div>
        </footer>

        <CustomScrollbar targetRef={shellRef} />

        <EnterKey />
      </div>
    </StepSubmitProvider>
  )
}
